var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 14.6668C11.2364 14.6668 12.4234 14.1752 13.2985 13.3C14.1737 12.4248 14.6654 11.2378 14.6654 10.0002C14.6654 8.76249 14.1737 7.5755 13.2985 6.70033C12.4234 5.82516 11.2364 5.3335 9.9987 5.3335C8.76102 5.3335 7.57404 5.82516 6.69887 6.70033C5.8237 7.5755 5.33203 8.76249 5.33203 10.0002C5.33203 11.2378 5.8237 12.4248 6.69887 13.3C7.57404 14.1752 8.76102 14.6668 9.9987 14.6668Z",
    stroke: "#35d169",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 11.3332C10.3549 11.3332 10.6941 11.1927 10.9441 10.9426C11.1942 10.6926 11.3346 10.3535 11.3346 9.99984C11.3346 9.64622 11.1942 9.30708 10.9441 9.05703C10.6941 8.80698 10.3549 8.6665 10.0013 8.6665C9.64768 8.6665 9.30854 8.80698 9.05849 9.05703C8.80844 9.30708 8.66797 9.64622 8.66797 9.99984C8.66797 10.3535 8.80844 10.6926 9.05849 10.9426C9.30854 11.1927 9.64768 11.3332 10.0013 11.3332Z",
    stroke: "#35d169",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
    stroke: "#35d169",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitTarget);
export default __webpack_public_path__ + "static/media/profitTarget.36f99980ce863d469da99ede04ff5fad.svg";
export { ForwardRef as ReactComponent };